import React from "react";
import "./custom-height-input.scss";
class CustomHeightInput extends React.Component {
  render() {
    return (
      <div className="custom-height-input">
        <h3>Height</h3>
        <input type={"number"} placeholder={"Feet"} />
        <input type={"number"} placeholder={"Inches"} />
      </div>
    );
  }
}

export default CustomHeightInput;
